module.exports = __webpack_public_path__ + "static/media/me-8.aaf3aa4a.svg";